import { isServiceWorker } from '@chilipiper/utils'
import RoxSSR from 'rox-ssr'
import RoxBrowser from 'rox-browser'

export default isServiceWorker ? (RoxSSR as unknown as typeof RoxBrowser) : RoxBrowser
